import React, { useState, useEffect } from "react";
import Masonry from "react-masonry-css";
import InteractiveImage from "./InteractiveImage";
import MyExparience from "./interactiveExparience";
import "./interactiveImage.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

export default function MyDesignList(props) {
  const { t } = useTranslation();
  const role = useSelector((state) => state.user?.currentUser?.account?.role);
  const [expariences, setExpariences] = useState(null);
  const [myDesigns, setMyDesigns] = useState(null);
  const breakpointColumnsObj = {
    default: 4,
    1100: 4,
    700: 3,
    500: 2,
  };

  useEffect(() => {
    if (props.myExpariences && props.myExpariences.length >= 0) {
      let tmpExpariences = [...props.myExpariences];
      if (!props.myExpariences[0] || props.myExpariences[0].id !== "addOne") {
        if (role === "ADMIN") {
          tmpExpariences.splice(0, 0, {
            name: t("myExpariences.addNewExparienceTile"),
            id: "addOne",
            imageUrl: "https://picsum.photos/200/300",
          });
        }
      }
      setExpariences(tmpExpariences);
    }

    if (props.myDesigns && props.myDesigns.length >= 0) {
      let tmpMyDesigns = [...props.myDesigns];
      if (!props.myDesigns[0] || props.myDesigns[0].id !== "addOne") {
        if (role === "ADMIN") {
          tmpMyDesigns.splice(0, 0, {
            name: !props.zonesMode
              ? t("homePage.myDesign.addNewDesign")
              : t("homePage.myDesign.addNewZones"),
            id: "addOne",
            imageUrl: "https://picsum.photos/200/300",
          });
        }
      }
      setMyDesigns(tmpMyDesigns);
    }
  }, [props.myDesigns, props.myExpariences, role]);

  if (myDesigns || expariences) {
    console.log("myDesigns", myDesigns);
    return (
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
        sx={{ position: "relative" }}
      >
        {/* 1 because of the card added to create myDesign */}
        {myDesigns?.length <= 0 && role !== "ADMIN" ? (
          <Typography
            variant="body1"
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            {t("homePage.myDesign.noResults")}
          </Typography>
        ) : myDesigns?.length > 0 ? (
          myDesigns.map((myDesign, index) => {
            if (props.isCrm && index === 0) return null;
            else
              return (
                <InteractiveImage
                  myDesign={myDesign}
                  key={`mydesign-${index + 1}`}
                  noPic={props.noPic}
                  zonesMode={props.zonesMode}
                  frameName={props.frameName}
                  target={props.target}
                  isAdmin={role === "ADMIN"}
                  addCard={index === 0 && role === "ADMIN" ? true : false}
                  parentUrl={props.parentUrl}
                />
              );
          })
        ) : (
          expariences.map((myExparience, index) => {
            return (
              <MyExparience
                myExparience={myExparience}
                key={`myExparience-${myExparience._id}`}
                addCard={index === 0 && role === "ADMIN" ? true : false}
                isAdmin={role === "ADMIN"}
                redirectUrlWithId={props.redirectUrlWithId}
              />
            );
          })
        )}
      </Masonry>
    );
  } else {
    return null;
  }
}
